import React, { FC } from 'react';
import { ResourceListSkeleton } from 'src/components/widgets/resourceList';
import { SkeletonBlock, SkeletonPageHeader, SkeletonPageShell, SkeletonStack } from 'src/components/widgets/skeleton';

export const PrintTypesPageSkeleton: FC = () => (
    <SkeletonPageShell aria-hidden='true'>
        <SkeletonPageHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width='min(260px, 100%)' $height='26px' />
                <SkeletonBlock $width='min(460px, 100%)' $height='13px' />
            </SkeletonStack>
            <SkeletonBlock $width='92px' $height='36px' $radius='6px' />
        </SkeletonPageHeader>
        <ResourceListSkeleton tableColumns={['minmax(180px, 1fr)', '140px', '84px']} />
    </SkeletonPageShell>
);
